var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"width":"100%"}},[_c('tr',[_c('td',{style:({ backgroundColor: _vm.logo.color }),attrs:{"align":"center","height":"120px"}},[_c('img',{attrs:{"src":_vm.logo.url,"width":_vm.width,"alt":_vm.logo.url}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }